/**
 * Menu View
 */
define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var core = require('core');
    var MenuView = require('modules/menu/menu.view');
    var user = require('user');
    var authManager = require('auth');
    var config = require('config');
    var device = require('util/device.util');
    var i18n = require('i18n');
    var url = require('util/url.util');
    var storage = require('util/storage.util');
    var PageManager = require('managers/totalcasino-theme/page.manager');

    module.exports = MenuView.extend({
        mixins: [
            'menuViewPopup'
        ],

        pos: {
            top: 0,
            left: 0,
            x: 0,
            y: 0
        },

        className: 'fn-slide-menu slide-menu-inner',

        events: _.extend({}, MenuView.prototype.events, {
            'tap .fn-login': 'openLoginPopup',
            'tap .fn-quick-deposit': 'goToDeposit',
            'tap .fn-toggle-balance': 'toggleBalance',
            'tap .fn-logout': 'logout',
            'tap .fn-add-page-to-fav': 'addPageToFavorites',
            'tap .fn-refer-a-friend': 'handleReferFriendItemTap',
            'tap .fn-account-verification': 'handleVerificationRedirect',
            'mousedown .menu__nav-wrapper': 'mouseDownHandler',
            'dragstart .menu__nav-link': 'menuDragHandler',
            'scroll .menu__nav-wrapper': 'toggleMenuScrollIndicator'
        }),

        subscribe: function() {
            this.listenTo(core, {
                'user:toggleBalance': this.toggleHideBalanceIcon.bind(this),
                'user:setSubscriptions': this.toggleHideInboxIcon.bind(this),
                'page:rendered': this.toggleMenuScrollIndicator.bind(this)
            });
            return MenuView.prototype.subscribe.apply(this, arguments);
        },

        handleNavigate: function(model) {
            this.model && model && this.model.set(model);
            MenuView.prototype.handleNavigate.call(this, model);
        },

        render: (function() {
            var render = function() {
                this.setActiveMenu = function() {
                };
                MenuView.prototype.render.apply(this, arguments);
                delete this.setActiveMenu;
                render = MenuView.prototype.render;
            };

            return function() {
                render.apply(this, arguments);
                this.listenTo(core, 'user:toggleBalance', this.setBalanceText);
                this.setBalanceText();

                return this;
            };
        })(url),

        handleReferFriendItemTap: function() {
            window.Playtech.API.popup.showPopup({
                id: 'referAFriend',
                className: 'refer-a-friend',
                title: this.translate('playtech.mobile.system.referaFriend.title'),
                articleId: 'REFER_FRIEND',
                buttons: []
            });

            this.listenToOnce(core, 'refer-a-friend:success', function() {
                window.Playtech.API.popup.closePopups('referAFriend');
            });
        },

        toggleHideBalanceIcon: function() {
            var hideBalance = user.get('hideBalance');

            $('.fn-toggle-balance .slide-menu__icon')
                .toggleClass('micon-show-balance', hideBalance)
                .toggleClass('micon-hide-balance', !hideBalance);
        },

        toggleHideInboxIcon: function() {
            const showInbox = user.getReceiveInboxStatus();

            $('.navigation-bar__point--inbox')
                .toggleClass('hidden', !showInbox);

            $('.slide-menu__point--inbox')
                .toggleClass('hidden', !showInbox);
        },

        _renderSideMenu: function() {
            var userDetails = user.get('userDetails');
            var userName = userDetails ? userDetails.username : null;

            this.$el.html(this.tmpl('side.menu', {
                menuItems: this.menuItems,
                isUserLogged: user.isLogin(),
                hideBalance: user.get('hideBalance'),
                userName: userName,
                menuGamesWebContent: this.menuGamesWebContent
            }).replace());

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },

        logout: function(e) {
            e.stopPropagation();
            e.preventDefault();

            core.trigger('auth:action:logout');
        },

        close: function() {
            MenuView.prototype.close.call(this, function() {
                this.el.scrollLeft = 0;
            }.bind(this));
        },

        addPageToFavorites: function() {
            if (window.sidebar && window.sidebar.addPanel) {
                window.sidebar.addPanel(document.title, window.location.href, '');
            } else if (window.external && window.external.AddFavorite) {
                window.external.AddFavorite(location.href, document.title);
            } else if (window.opera && window.print) {
                this.title = document.title;
                return true;
            } else {
                var message = device.os === 'macintosh' ?
                    i18n.t('playtech.mobile.system.addPageToFavoritesTextMac') :
                    i18n.t('playtech.mobile.system.addPageToFavoritesText');

                /* eslint-disable */
                alert(message);
                /* eslint-enable */
            }
        },

        setActiveMenu: function(pageUrl) {
            this.$('.active').removeClass('active');

            // Override core functionality of highlighting
            // 3rd level menu containers
            const currentParentItems = this.model.getCurrentParentItems(pageUrl);
            const currentItem = this.model.getCurrentItem(pageUrl);
            const currentParentItem = this.model.getCurrentParentItem(pageUrl);

            [...currentParentItems, currentItem, currentParentItem].forEach(function(item) {
                if (!item) {
                    return;
                }
                var $link = this.$('[data-url="' + item.friendlyURL + '"]');

                if (!$link.length) {
                    $link = $('.fn-navigation-bar-container').find('a[href="' + item.friendlyURL + '"]').parent();
                }

                !$link.hasClass('fn-accordion') && $link.addClass('active');
            }, this);

            if (this.$('.mobile-cat-home').hasClass('active')) {
                this.$('.mobile-active-home').addClass('active');
            }
        },

        handleVerificationRedirect: function(e) {
            var serviceUrl = e.target.href;
            if (serviceUrl) {
                e.stopPropagation();
                e.preventDefault();
                var serviceSystemId = config.get('verificationServiceSystemId') || '620';
                var verificationRedirect = function(response) {
                    var token = response && response.data && response.data.token;
                    serviceUrl += '&' + url.serialize({
                        user: user.get('userName'),
                        token: token
                    });
                    core.navigate(serviceUrl);
                };
                authManager.getTemporaryAuthenticationToken(null, serviceSystemId).done(verificationRedirect);
            }
        },

        openLoginPopup: function(e) {
            e.preventDefault();

            /* TotalCasino changes */
            const { pathname, search } = window.location;
            const newBackURLWithSearch = `${pathname}${search}`;

            if (config.get('loginPage')) {
                storage.session.setItem('backPageUrl', url.getCleanUrl(newBackURLWithSearch));
            }
            /* TotalCasino changes */

            this.handleCloseTap();
            Playtech.API.auth.showLogin({
                afterLoginUrl: newBackURLWithSearch
            });
        },

        getBalanceText: function() {
            return user.get('hideBalance')
                ? this.translate('playtech.mobile.system.menu.show-balance')
                : this.translate('playtech.mobile.system.menu.hide-balance');
        },

        setBalanceText: function() {
            this.$('span.fn-balance-text').html(this.getBalanceText());
        },

        toggleBalance: function() {
            user.set('hideBalance', !user.get('hideBalance'));
            core.trigger('user:toggleBalance');
            this.setBalanceText();
        },

        showSubMenu: function(target) {
            this.isMenuShown = true;
            this.$('.fn-sub-menu-item, .fn-menu-subnavigation, .fn-submenu').addClass('hidden');

            if (target.dataset.type === 'hover') {
                this.$('.fn-menu-subnavigation').removeClass('hidden');
                this.$('.fn-menu-subnavigation .fn-sub-menu-item[data-url="' + target.dataset.url + '"]').removeClass('hidden');
            } else {
                this.$('.fn-menu-nav-item[data-url="' + target.dataset.url + '"] .fn-submenu').removeClass('hidden');
            }
            const $linkElContainer = this.$('.fn-menu-nav-item[data-url="' + target.dataset.url + '"]')[0];
            const $container = this.$('.fn-navigation .menu__nav-wrapper')[0];
            const $menuWrapper = $('.fn-slide-menu')[0];
            /* position subpages container under link */
            var left = $menuWrapper.offsetLeft + $linkElContainer.offsetLeft - $container.scrollLeft + 'px';
            var subPagesContainer = this.$('.fn-submenu')[0];
            subPagesContainer.style.left = left;
        },
        menuDragHandler: function(e) {
            e.preventDefault();
            return false;
        },
        mouseDownHandler: function(e) {
            const ele = document.querySelector('.menu__nav-wrapper');
            this.pos = {
                // The current scroll
                left: ele.scrollLeft,
                top: ele.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY
            };
            ele.style.cursor = 'grabbing';
            ele.style.userSelect = 'none';

            const mouseMoveHandler = (ev) => {
                // How far the mouse has been moved
                const dx = ev.clientX - this.pos.x;
                const dy = ev.clientY - this.pos.y;

                // Scroll the element
                ele.scrollTop = this.pos.top - dy;
                ele.scrollLeft = this.pos.left - dx;
            };
            const mouseUpHandler = () => {
                ele.style.cursor = 'grab';
                ele.style.removeProperty('user-select');
                ele.removeEventListener('mousemove', mouseMoveHandler);
                ele.removeEventListener('mouseup', mouseUpHandler);
                ele.removeEventListener('mouseout', mouseUpHandler);
                this.toggleMenuScrollIndicator();
            };

            ele.addEventListener('mousemove', mouseMoveHandler);
            ele.addEventListener('mouseup', mouseUpHandler);
            ele.addEventListener('mouseout', mouseUpHandler);
        },
        toggleMenuScrollIndicator: function() {
            const $menuWrapper = this.el.querySelector('.menu__nav-wrapper');
            if (device.formFactor === 'desktop' && $menuWrapper) {
                const $menuNav = $menuWrapper.querySelector('.menu__nav');
                const isScrollIndicatorHidden =
                    $menuWrapper.scrollLeft + $menuWrapper.clientWidth > $menuNav.clientWidth + 10;
                this.$('.menu__scroll-indicator')
                    .toggleClass('hidden', isScrollIndicatorHidden);
            }
        },

        goToDeposit: function(e) {
            var depositPageURL = PageManager.getCashierDepositPageURL();

            if (depositPageURL) {
                e.stopImmediatePropagation();
                core.navigate(depositPageURL);
            }
        }
    });
});
